import React from "react";
import { DW_CHECKLIST_STATUSES } from "../constants/drinking-water-checklist-statuses";

/**
 * Status chip styling that is chosen by status *key* rather than by its German label.
 *
 * The status grid has always coloured chips by the displayed name, which breaks down as
 * soon as two workflows share one: "Labortermin abwarten" belongs to both order handling
 * (blue) and the Trinkwasser checklist (red), and "Vorabklärung" is used by three
 * workflows. Keys are unique, so the checklist picks its colours here and everything
 * else keeps falling through to the existing name-based rules untouched.
 *
 * Each phase of the checklist gets its own colour, as the drinking water team asked.
 */

/** Brown for phase 1 - the theme has green/red/blue ramps but no brown. */
const BROWN = "#8d6e63";
const BROWN_DARK = "#5d4037";

export const getStatusKeyChipStyle = (
    statusKey: string | undefined,
    colors: any,
    mode: "light" | "dark"
): React.CSSProperties | null => {
    const isDark = mode === "dark";

    switch (statusKey) {
        // Phase 1 - Vorabklärung
        case DW_CHECKLIST_STATUSES.PRE_CLARIFICATION:
            return { backgroundColor: isDark ? BROWN_DARK : BROWN, color: "#ffffff" };

        // Phase 2 - Auftrag/Terminierung
        case DW_CHECKLIST_STATUSES.ORDER_SCHEDULING:
            return {
                backgroundColor: isDark ? colors.greenAccent[700] : colors.greenAccent[500],
                color: "#000000",
            };

        // Phase 3 - Labortermin abwarten
        case DW_CHECKLIST_STATUSES.AWAITING_LAB_DATE:
            return {
                backgroundColor: isDark ? colors.redAccent[700] : colors.redAccent[500],
                color: "#000000",
            };

        // Phase 4 - Eingang Prüfbericht abwarten
        case DW_CHECKLIST_STATUSES.AWAITING_LAB_REPORT:
            return {
                backgroundColor: isDark ? colors.blueAccent[700] : colors.blueAccent[500],
                color: "#ffffff",
            };

        default:
            return null;
    }
};
